"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toArray = exports.listToTree = exports.filterUnique = exports.makeArray = void 0;
var assertFunctions_1 = require("./assertFunctions");
function makeArray(len, start) {
    if (start === void 0) { start = 0; }
    assertFunctions_1.assertNumber(len);
    assertFunctions_1.assertNumber(start);
    return start > 0
        ? __spread(Array(len + start).keys()).filter(function (i) { return i >= start; })
        : __spread(Array(len).keys());
}
exports.makeArray = makeArray;
/**
 * 过滤数组中重复集合
 * @param arr
 */
function filterUnique(arr) {
    return arr.filter(function (value, index, items) {
        return items.indexOf(value) === index;
    });
}
exports.filterUnique = filterUnique;
/**
 * 转换数组为树型嵌套结构
 * @param items
 * @param id 根元素ID
 * @param parentKey 父元素 key 名
 */
function listToTree(items, id, parentKey) {
    if (id === void 0) { id = 0; }
    if (parentKey === void 0) { parentKey = "pid"; }
    return items
        .filter(function (item) { return item[parentKey] === id; })
        .map(function (item) { return (__assign(__assign({}, item), { children: listToTree(items, item.id) })); });
}
exports.listToTree = listToTree;
/**
 * 转换为数组
 * @param arr
 */
function toArray(arr) {
    if (arr == null) {
        return [];
    }
    return Array.isArray(arr) ? arr : [arr];
}
exports.toArray = toArray;
